import React from "react";
import imgLogo from "../assets/logos/holistique_blanco.webp";
import "./BannerContacto.css";

export default function Contacto() {
  return (
    <div className="banner-contacto">
        <div className="banner-contacto-content">
            <div className="logo-section">
                <img src={imgLogo} alt="" />
            </div>
        </div>
        <div className="form-contact">
            <div className="contact-form-container">
                <h2>Contáctenos</h2>
                <form>
                  <div className="form-group">
                    <label>Nombre</label>
                    <input type="text" placeholder="Tu nombre" />
                  </div>

                  <div className="form-group">
                    <label>Correo</label>
                    <input type="email" placeholder="tu@correo.com" />
                  </div>

                  <div className="form-group">
                    <label>Mensaje</label>
                    <textarea placeholder="Escribe tu mensaje..." />
                  </div>

                  <button type="submit">Enviar</button>
                </form>
            </div>
        </div>
    </div>
  );
}